import type { GetUserInfoResponse } from 'tokyu-hooks/lib/response/smartclub/user'
import type { GetCreditCardListResponse } from 'tokyu-hooks/lib/response/membership'
import type { GetPointExpiringSummaryResponse } from 'tokyu-hooks/lib/response/smartclub/point'
import type {
  MembershipDetailModel,
  PointDetailModel,
  PointExpirySummaryModel,
  CreditCardModel,
} from './types'

export const POINT_MINIMUM_USAGE_UNIT = 100
export const POINT_USAGE_UNIT = 100
export const EXPIRY_BUCKET_DAYS = [30, 60, 90, 120, 150, 180, 365] as const

export const toPointDetailModel = (
  data: MembershipDetailModel,
): PointDetailModel => ({
  minimumUsageUnit: POINT_MINIMUM_USAGE_UNIT,
  usageUnit: POINT_USAGE_UNIT,
  totalPoint: data?.pointBalance || 0,
  totalValue: data?.pointBalance || 0,
})

export const toMembershipDetailModel = (
  data: GetUserInfoResponse,
): MembershipDetailModel => ({
  birthday: data.birth_date
    ? new Date(data.birth_date.replace(/-/g, '/'))
    : undefined,
  country: data.country || undefined,
  email: data.email || undefined,
  firstName: data.first_name || undefined,
  firstNameKana: data.first_name_kana || undefined,
  gender: data.gender || undefined,
  lastName: data.last_name || undefined,
  lastNameKana: data.last_name_kana || undefined,
  phone: data.tel || undefined,
  postalCode: data.zip_code || undefined,
  prefectureOrState: data.prefacture || undefined,
  buildingNameAndNumber: data.address1 || undefined,
  streetAddress: data.address2 || undefined,
  pointBalance: data.point_balance,
  medalBalance: data.medal_balance,
  rankNumber: data.rank || undefined,
  rankName: data.rank_data?.display_rank || undefined,
  emailNewsletterStatus: data.email_newsletter_status || undefined,
})

export const toPointExpirySummaryModel = (
  data: GetPointExpiringSummaryResponse,
): PointExpirySummaryModel => ({
  buckets: EXPIRY_BUCKET_DAYS.reduce(
    (acc, day) => ({
      ...acc,
      [day]: data.expiring_within_days[String(day)] || 0,
    }),
    {} as Record<number, number>,
  ),
  within60Days: data.expiring_within_days['60'] || 0,
})

export const toCreditCardListModel = (
  data: GetCreditCardListResponse,
): CreditCardModel[] =>
  data.data.map((card) => ({
    sequence: card.sequence,
    number: card.number,
    name: card.name,
    expire: card.expire,
    gateway: card.gateway,
    brand: card.card_brand,
  }))
